import { render, staticRenderFns } from "./EmailTfaConfig.vue?vue&type=template&id=63976f8e&scoped=true"
import script from "./EmailTfaConfig.vue?vue&type=script&lang=js"
export * from "./EmailTfaConfig.vue?vue&type=script&lang=js"
import style0 from "./EmailTfaConfig.vue?vue&type=style&index=0&id=63976f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63976f8e",
  null
  
)

export default component.exports